import React from 'react';
import { Link } from 'react-router-dom';

import heroImage from '../assets/images/team.jpg';
import tenantImage from '../assets/images/happy.jpg';
import './styles/Partners.css';

const partnerTracks = [
  
  {
    title: 'Schools, Universities & Housing',
    description:
      'Make move-in/move-out and summer storage effortless with bulk programs and student-friendly pricing.',
    bullets: ['Referral payouts', 'Seasonal storage programs', 'Bulk coordination'],
    tag: 'For Schools & Clubs',
    cta: 'Start a Campus Program',
    link: '/Contact',
  },
  {
    title: 'Apartment Complexes & Property Managers',
    description:
      'Increase resident satisfaction and reduce move-in/move-out stress with concierge storage.',
    bullets: ['Referral payouts', 'Resident discounts', 'Building-wide programs',],
    tag: 'For Realtors and Property Managers',
    cta: 'Become a Property Partner',
    link: '/Contact',
  },
  {
    title: 'Movers & Moving Companies',
    description:
      'Offer customers a seamless option storage, while increasing business.',
    bullets: ['Referral payouts', 'Drive leads for your business', 'Win more jobs with bundled storage'],
    tag: 'For Movers',
    cta: 'Partner with Bins',
    link: '/Contact',
  },
];

const programTypes = [
  {
    title: 'Referral Program',
    description:
      'Earn for every customer you send to Bins with tracked links and direct payouts.',
  },
  {
    title: 'Exclusive Discounts',
    description:
      'Offer your customers or residents a discount they’ll actually use.',
  },
  {
    title: 'Co-Marketing & Move-In Resources',
    description:
      'We’ll provide co-branded assets like flyers, email templates, and landing-page copy to help you drive signups.',
  },
];

const howItWorks = [
  {
    heading: '1. Quick Setup',
    body:
      'We align on your audience, program type (referrals, discounts, seasonal), and give you everything you need to share.',
  },
  {
    heading: '2. Start Referring',
    body:
      'Send customers via a tracked link or discount code. We handle pickup, storage, and returns—end to end.',
  },
  {
    heading: '3. Track + Optimize',
    body:
      'You’ll see what’s working, we’ll improve conversion, and we’ll help expand your program over time.',
  },
];

const Partners = () => (
  <main className="partners-page">
    {/* HERO */}
    <section className="partners-hero">
      <div className="partners-hero-content">
        <span className="partners-badge">Bins Partner Program</span>
        <h1>Deliver modern storage for your customers, while earning referrals.</h1>
        <p>
          We collaborate with businesses and
          organizations to make storage effortless for your customers.
        </p>
        <div className="partners-hero-actions">
          <a
            href="https://forms.gle/PHRp94mEXxvQFcv8A"
            target="_blank"
            rel="noopener noreferrer"
            className="partners-button partners-button-primary"
          >
            Become a Partner
          </a>
        </div>
      </div>
      <div className="partners-hero-media">
        <img src={heroImage} alt="Bins partners and customers" />
      </div>
    </section>

    {/* PARTNER TYPES (Bellhop-like tiles) */}
    <section id="partner-types" className="partners-partner-types">
      <div className="partners-types-header">
        <h2>Who We Partner With</h2>
        <p className="partners-section-subtext">
          From referrals to seasonal programs, Bins helps you provide a better experience and unlock new revenue.
        </p>
      </div>

      <div className="partners-types-grid">
        {partnerTracks.map((t) => (
          <article key={t.title} className="partners-type-card">
            <div className="partners-type-tag">{t.tag}</div>
            <p>{t.description}</p>

            <ul className="partners-type-bullets">
              {t.bullets.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>

  
    {/* PROGRAM TYPES (Bellhop-like: shows the “ways to partner”) */}
    <section className="partners-benefits">
      <h2>How We Work With You</h2>
      <p className="partners-section-subtext">
        We'll help you set up a program that matches your audience. We’ll provide tracking, support, and co-branded assets.
      </p>

      <div className="partners-benefit-grid partners-program-grid">
        {programTypes.map((p) => (
          <article key={p.title} className="partners-benefit-card partners-program-card">
            <h3>{p.title}</h3>
            <p>{p.description}</p>
          </article>
        ))}
      </div>
    </section>

    {/* CTA */}
    <section className="partners-cta">
      <img src={tenantImage} alt="Customer using Bins storage experience" />
      <div>
        <h2>Let’s build a referral program that works for your audience.</h2>
        <p>
          Whether you want a simple referral link, an exclusive discount, or a seasonal campus program, let us know and we'll make it happen.
        </p>
        <div className="partners-hero-actions">
          <a
            href="mailto:contact@bins-storage.com"
            className="partners-button partners-button-primary"
          >
            Schedule an Intro Call
          </a>

          <a
            href="https://forms.gle/PHRp94mEXxvQFcv8A"
            target="_blank"
            rel="noopener noreferrer"
            className="partners-button partners-button-secondary"
          >
            Become a Partner
          </a>
        </div>
      </div>
    </section>
  </main>
);

export default Partners;